import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const BuyRentTabsWrapper = styled('div')((props) => {
    const {
        theme: { borderRadius, mq, colors }
    } = props;

    return css`
        width: 100%;
        height: 48px;
        background-color: ${colors['graphic-background-accent-light']};
        border-radius: ${borderRadius['300']};
        display: flex;

        ${mq.medium} {
            max-width: fit-content;
        }
    `;
});

export type BuyRentTabProp = {
    isSelected: boolean;
};

export const BuyRentTab = styled('a')<BuyRentTabProp>((props) => {
    const {
        theme: {
            borderRadius,
            spacing,
            colors,
            mq,
            focusRing,
            type,
            fontSizes
        },
        isSelected
    } = props;

    return css`
        flex-basis: 33%;
        padding: 0 0.75rem;
        text-decoration: none;
        width: 33.333%;
        border-radius: ${borderRadius['300']};
        font-size: ${spacing['16px']};
        cursor: pointer;
        font-family: inherit;
        font-size: ${fontSizes[1]};
        display: flex;
        align-items: center;
        justify-content: center;
        border: 0;
        outline: none;
        background-color: ${isSelected
            ? colors['graphic-background-contrast']
            : colors['transparent']};
        font-weight: ${isSelected ? type['semiBold'] : 'none'};
        color: ${isSelected ? colors.white : colors.black};
        white-space: nowrap;

        ${mq.medium} {
            width: auto;
            padding: 0 ${spacing['16px']};
        }

        &:focus {
            box-shadow: ${focusRing};
            outline: 0;
            z-index: 1;
        }
    `;
});
